import React from "react";
import LegalLayout from "./LegalLayout";

const TermsConditions = () => (
  <LegalLayout
    title="Terms & Conditions"
    subtitle="Pawansut Holdings Limited — RBI-registered NBFC"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      These Terms and Conditions govern your use of the services and digital
      platforms of Pawansut Holdings Limited (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;), an
      RBI-registered Non-Banking Financial Company (NBFC). By accessing our
      website or availing our financial products and services, you agree to be
      bound by these terms.
    </p>

    <section>
      <h2>1. Eligibility and Acceptance</h2>
      <p>
        You must be a resident of India, of sound mind, and meeting the
        eligibility criteria specified for each product to use our services. Use
        of our website or services constitutes acceptance of these Terms &
        Conditions and our Privacy Policy.
      </p>
    </section>

    <section>
      <h2>2. Products and Services</h2>
      <p>
        Pawansut Holdings Limited offers lending, investment, and related
        financial products as an NBFC. Product-specific terms, interest rates,
        fees, and tenure are disclosed at the time of application and in the
        sanction letter. We reserve the right to modify product features with
        due notice where required by law.
      </p>
    </section>

    <section>
      <h2>3. Accuracy of Information</h2>
      <p>
        You agree to provide accurate, complete, and current information in all
        applications and communications. We may verify the information through
        third parties and refuse or withdraw services if we find any
        misrepresentation or fraud.
      </p>
    </section>

    <section>
      <h2>4. Fees, Charges and Repayment</h2>
      <p>
        All applicable fees, processing charges, and interest are disclosed
        before you accept a product. You are responsible for timely repayment
        as per the agreed schedule. Default may attract penal charges and
        impact your credit profile as per our Recovery Policy and applicable
        laws.
      </p>
    </section>

    <section>
      <h2>5. Intellectual Property and Use of Website</h2>
      <p>
        Content on our website, including logos, text, and graphics, is owned by
        Pawansut Holdings Limited. You may not copy, distribute, or use it for
        commercial purposes without our written consent. You must not use our
        systems for any unlawful purpose or to transmit malware or harmful code.
      </p>
    </section>

    <section>
      <h2>6. Limitation of Liability</h2>
      <p>
        To the extent permitted by law, we are not liable for indirect,
        incidental, or consequential damages arising from your use of our
        services or website. Our liability is limited to the extent permitted
        under applicable Indian laws and the specific contract between you and
        the Company.
      </p>
    </section>

    <section>
      <h2>7. Governing Law and Disputes</h2>
      <p>
        These terms are governed by the laws of India. Any dispute shall be
        subject to the exclusive jurisdiction of the courts at Delhi. Our
        Grievance Redressal Policy applies to complaints related to our
        products and services.
      </p>
    </section>

    <section>
      <h2>8. Changes to Terms</h2>
      <p>
        We may update these Terms & Conditions from time to time. The revised
        version will be posted on our website with an updated &quot;Last updated&quot;
        date. Continued use of our services after changes constitutes
        acceptance of the revised terms.
      </p>
    </section>

    <section>
      <h2>9. Contact</h2>
      <p>
        For queries regarding these Terms & Conditions, please contact us
        through the &quot;Contact Us&quot; section on our website or write to our
        registered office. Our Grievance Redressal Officer can be reached as per
        details in the Grievance Redressal Policy.
      </p>
    </section>
  </LegalLayout>
);

export default TermsConditions;
